export const featuresSectionData = {
	heading: "Discover the Power of Mental Health, Fitness, and Nutrition",
	description:
		"Welcome to our health and wellness blog, where we share articles on mental health, fitness, nutrition, and self-care. Our goal is to provide you with valuable information and resources to help you live a healthier and happier life.",
	features: {
		item: [
			{
				src: "/images/bannerImages/img(1).jpg",
				alt: "Mental Health Matters",
				heading: "Mental Health Matters",
				description:
					"Learn about the importance of mental well-being and discover strategies to improve your mental health.",
			},
			{
				src: "/images/bannerImages/img(2).jpg",
				alt: "Fitness for All",
				heading: "Fitness for All",
				description:
					"Get inspired to stay active and fit with our fitness tips, workout routines, and success stories.",
			},
			{
				src: "/images/bannerImages/img(3).jpg",
				alt: "Nourish Your Body",
				heading: "Nourish Your Body",
				description:
					"Discover the power of nutrition and learn how to make healthy food choices for a balanced lifestyle.",
			},
		],
	},
};
